/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Working hours per day. Keys are ISO 8601 weekday numbers (1=Monday, 7=Sunday)
 */
export type ScheduleConfigWorkingHours = {
  [key: string]: {
    end?: string;
    start?: string;
  };
};
